export default "__VITE_ASSET__Dlo2toSR__"